export * from './score-answer.component'
export * from './types'
